import Resource from "../base/resource";
import BoundaryFactory from '../../../services/boundary/boundary-factory';
import BoundaryService from '../../../services/boundary/boundary-service';

class Camera extends Resource {
    constructor(props) {
        super(props);
    }

    async load(onLoadCallback) {
        if (wv.effectController.stoppedTrainingId === TrainingTreeController._trainingFeature.getActiveTraining()?.id) {
            return;
        }
        onLoadCallback(1);
    }

    async setState(state, {loadViewpoint, positionOnlyInXR, viewpointApplyMode}) {
        if (ARAuthoringController.alignmentModeActive) {
            return;
        }
        
        const shouldApplyLocks = !wv.trainingAuthoringEnabled && !this.ignoreLockMovementOrientation;
        
        if (shouldApplyLocks) {
            if (!isNullOrUndefined(state.lockMovement)) {
                wv.effectController.lockUserMovement = state.lockMovement;
                VR.mouseControls.enablePan = !state.lockMovement;
            }

            if (!isNullOrUndefined(state.lockOrientation)) {
                wv.effectController.lockUserOrientation = state.lockOrientation;
                VR.mouseControls.enableRotate = !state.lockOrientation;
            }

            if (state.lockMovement) setMouseControlMode(MouseControlMode.ROTATE);
        } else {
            wv.effectController.lockUserMovement = false;
            wv.effectController.lockUserOrientation = false;
            VR.mouseControls.enableRotate = true;
            VR.mouseControls.enablePan = true;
        }

        if (loadViewpoint === false) return;
        if (wv.arAlignmentModeActive) return;


        const position = state.position ? new THREE.Vector3(...state.position) : undefined;
        let quaternion = state.quaternion ? new THREE.Quaternion(...state.quaternion) : undefined;

        if (positionOnlyInXR && viewpointApplyMode === '2D and XR' && (isVRModeEnabled() || isMobileARModeEnabled())) {
            const cameraQuaternion = iq3Camera.getConfigurationWorld().orientation;
            quaternion = new THREE.Quaternion(cameraQuaternion.x, cameraQuaternion.y, cameraQuaternion.z, cameraQuaternion.w);
        }

        iq3Camera.attchCameraToBody();
        iq3Camera.setConfiguration(position, quaternion);

        wv.userNavigation.resetLastValidPosition();

        if (isMobileARModeEnabled() && state.arOffset) {
            setTimeout(() => {
                setCameraPositionByDistance(state.arOffset)
            }, 0)
        }

        updateInputMenuConfig(600);
    }

    getDefaultState() {
        const configuration = iq3Camera.getConfigurationWorld();
        return {
            position: configuration.position.toArray(),
            quaternion: configuration.orientation.toArray(),
            lockMovement: false,
            lockOrientation: false,
            boundaries: []
        };
    }
}

export default Camera;
